module.exports = __webpack_public_path__ + "img/signup-guide-01-02.39145313.png";